<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3"
                        :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                                @click="updateItem"
                                label="SAVE"
                                :disabled="!$checkRole($accessModule.supplier_contract_program, 'update')" ></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <b-form v-bind:class="{'run-loading':Loadings.popup}">
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-text-field class="mb-3" label="PM Code"  oneline>{{ sorItem.sor_code }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="5">
                                        <gofix-text-field class="mb-3" label="Description 01"  oneline>{{ sorItem.description_one }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="9" class="mt-10">
                                        <gofix-text-field label="Description 02"  oneline>{{ sorItem.description_two }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-text-field class="mb-3" label="Service Category"  oneline>{{ sorItem.service_category ? sorItem.service_category.name : "--" }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="5">
                                        <gofix-text-field class="mb-3" label="Equipment Group"  oneline>{{ sorItem.equipment_structure_type ? sorItem.equipment_structure_type.name : "--" }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="4" class="mt-10">
                                        <gofix-text-field class="mb-3" label="Frequency"  oneline>{{ sorItem.get_sor_recurring_mode ? sorItem.get_sor_recurring_mode.recurring_mode : "--" }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="5" class="mt-10">
                                        <gofix-text-field class="mb-3" label="Tolerance Period"  oneline>{{ sorItem.tolerance_period ? sorItem.tolerance_period + ' Days' : '--'  }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="9" class="mt-10">
                                        <gofix-text-field label="Checklist Template"  oneline>{{ sorItem.checklist ? sorItem.checklist.name_checklist_templates : "--" }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card classContent="mb-2 mt-4">
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input-number
                                                label="Unit Price"
                                                v-model="vendor_linking_sor.unit_price_tmp"
                                                prefix="$"></gofix-form-input-number>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Unit of Measurement" v-model="sorItem.unit_of_measurement"></gofix-form-input>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex';
    export default {
        name: 's-sor-detail',
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                normalizerService(node) {
                    return {
                        label: node.name
                    }
                },
                contractTerms: null,
                disabled: false,
                vendor_linking_sor: {},
            }
        },
        created () {
            //Check in C-contract
            if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/contract-supplier`);
            }

            if(!this.$route.params.hasOwnProperty('maintenance_id') || isNaN(this.$route.params.maintenance_id)) {
                return this.$router.push(`/v2/contract-supplier/${this.$route.params.id}/maintenance-program`);
            }

            if(this.ClientContractID && !this.contractTerms && this.ClientContractID.contract_terms){
                this.contractTerms = this.ClientContractID.contract_terms[0];
            }
            this.disabled = true;
            this.vendor_linking_sor.unit_price = this.sorItem.unit_price ? this.sorItem.unit_price : '';
            if(this.sorItem.vendor_linking_sor && this.sorItem.vendor_linking_sor.length > 0) {
                this.disabled = false;
                this.vendor_linking_sor = Object.assign({}, this.sorItem.vendor_linking_sor[0]);
                this.vendor_linking_sor.unit_price = JSON.stringify(Number(this.vendor_linking_sor.unit_price));
            }
            this.vendor_linking_sor.unit_price_tmp = this.vendor_linking_sor.unit_price != 0 ?  this.$accounting.formatMoney(this.vendor_linking_sor.unit_price) : '';

            if(this.$route.params.maintenance_id != 0 && this.sorItem.id != this.$route.params.maintenance_id){
                this.$store.dispatch("v2SorController/getItem",this.$route.params.maintenance_id)
                    .then(respone => {
                        this.vendor_linking_sor.unit_price = respone.data.data.unit_price;
                        if(respone.data.data.vendor_linking_sor && respone.data.data.vendor_linking_sor.length > 0) {
                            let vendor_linking_sor_supplier = respone.data.data.vendor_linking_sor.filter(item => item.supplier_contract_id == this.$route.params.id);
                            if(vendor_linking_sor_supplier.length) {
                                this.vendor_linking_sor = Object.assign({}, vendor_linking_sor_supplier[0]);
                                this.vendor_linking_sor.unit_price = JSON.stringify(Number(this.vendor_linking_sor.unit_price));
                                this.vendor_linking_sor.unit_price_tmp = this.vendor_linking_sor.unit_price != 0 ? this.$accounting.formatMoney(this.vendor_linking_sor.unit_price) : '';

                            }
                        }
                    });
            }


        },
        watch: {
            contractTerms: function (val) {
                this.loadService()
            },
            ClientContractID: function(val, old) {
                if(val && val.client_id !== old.client_id) {
                    return this.$router.push(`/v2/contract-supplier`)
                }
            },
        },
        computed: {
            ...mapGetters({
                Loadings:  'v2SorController/Loadings',
                Groups:  'v2SorController/Groups',
                sorItem:  'v2SorController/sorItem',
                Services:  'v2SorController/Services',
                Validate:  'v2SorController/Validate',
                ClientContractID: 'ContractController/ClientContractID',
                Items:  'v2SorController/Items'
            })
        },
        methods:{
            loadService(){
                this.$store.dispatch("v2SorController/getServices",this.ClientContractID.service_category_root_id);
            },
            loadOptionsService({ action, parentNode, callback,instanceId  }){
                if(parentNode.isBatch){
                    this.$store.dispatch("v2SorController/getService",{
                        contract_id:this.$route.params.id,
                        service_id:parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback()
                    })
                }else{
                    parentNode.children = undefined;
                    callback()
                }
            },
            updateItem(){

                this.vendor_linking_sor.unit_price = this.$accounting.unformat(this.vendor_linking_sor.unit_price_tmp);
                if(!this.vendor_linking_sor.id) {
                    return;
                }
                if(!this.vendor_linking_sor.unit_price) {
                    return this.$alertNotification("Unit price is required.", "danger");
                }
                this.$store.dispatch("v2SorController/saveVendorLinkingSOR", this.vendor_linking_sor).then( data => {
                    this.$alertNotification(this.$notificationV2('editing', 'vendor_linking_sor'));
                }).catch(err => {
                    if(err.response.data.error.message.error) {
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    } else {
                        this.$alertNotification("Error", "danger");
                    }
                });
            },
        }
    }
</script>
